module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_diamond__v_vector.ee45e905.svg";